import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import XFilledSvg from "@ant-design/icons-svg/es/asn/XFilled";
import AntdIcon from '../components/AntdIcon';
var XFilled = function XFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: XFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(XFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'XFilled';
}
export default RefIcon;